/**
 * Customized to add ContainerComponent prop and useHideWidgetContainer hook.
 */

import { RenderContent } from '@/components/blocks/RenderContent';
import { useContentRecommendation } from '@/data/Content/ContentRecommendation';
import { useContentEvents } from '@/data/Content/_ContentEvents';
import { WidgetComponentProps, WidgetProperties } from '@/data/types/Slot';
import { Box } from '@mui/material';
import { FC } from 'react';

const emptyProperties = {} as WidgetProperties;

type ContentRecommendationProps = WidgetComponentProps & {
	/**
	 * Do not apply any replacements to the content (See `parseHTMLValidate`).
	 */
	skipParsing?: boolean;
};

export const ContentRecommendation: FC<ContentRecommendationProps> = ({
	id: _id,
	properties = emptyProperties,
	skipParsing,
	sx,
}) => {
	const { emsName = '' } = properties;
	const { data, loading, title, eSpotName } = useContentRecommendation(emsName);
	const { onContentClick } = useContentEvents();

	if (loading || (!title?.length && !data?.length)) {
		return null;
	}

	return (
		<Box sx={sx} data-ems-name={eSpotName}>
			{title?.map((content) => (
				<RenderContent
					key={`${content.id}${content.contentId}`}
					content={content}
					onClick={onContentClick(content)}
					skipParsing={skipParsing}
				/>
			))}
			{data?.map((content) => (
				<RenderContent
					key={`${content.id}${content.contentId}`}
					content={content}
					onClick={onContentClick(content)}
					skipParsing={skipParsing}
				/>
			))}
		</Box>
	);
};
